import classcat from "classcat";
import React from "react";

import { Select } from "@touchtech/baselayer-ui";
import { IconTickCircle, Label } from "@touchtech/web-baselayer-ui";

import css from "./SelectField.module.css";

type Props = {
  error?: string;
  hasError?: boolean;
  label?: string;
  required?: boolean;
} & React.ComponentProps<typeof Select>;

function SelectField({
  error,
  hasError = false,
  label,
  required = false,
  ...props
}: Props) {
  return (
    <div>
      {label ? (
        <div className={classcat([css.selectContainer, "text-label-sm"])}>
          <Label required={required}>{label}</Label>
          <Select
            className={classcat([css.select, { [css.error]: error }])}
            {...props}
          />
        </div>
      ) : (
        <Select
          className={classcat([css.select, { [css.error]: error }])}
          {...props}
        />
      )}
      {hasError && !!error && (
        <div className={css.selectFieldError}>
          <div className={css.selectFieldErrorIcon}>
            <IconTickCircle />
          </div>
          {error}
        </div>
      )}
    </div>
  );
}

export default SelectField;
